import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { Button } from '../../atoms/Button/Button';
import { useTranslation } from '../../i18n/resources';
import { AppRoute } from '../../routes';
import { MediShareLogoIcon } from '../MediShareLogo/MediShareLogoIcon';
import styles from './ErrorMessage.module.css';

export type ErrorMessageProps = {
  className?: string;
  message?: string;
};

export const ErrorMessage: FunctionComponent<ErrorMessageProps> = ({
  className,
  message,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={cx(styles.container, className)}>
        <div>
          <MediShareLogoIcon
            fill="var(--color-background-contrast)"
            height={84}
          />
        </div>
        <div className={styles.message}>
          <div className={styles.title}>{t('error', 'title')}</div>
          <div className={styles.note}>{message ?? t('error', 'message')}</div>
        </div>

        <Button asChild color="primary" size="large">
          <a href={AppRoute['/logout']}>{t('common', 'log_out')}</a>
        </Button>
      </div>
    </div>
  );
};
